import React from 'react';
import { useCompanyPlan } from '../hooks/useCompanyPlan';
import { UpgradePrompt } from './UpgradePrompt';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requirePlan?: 'projeto' | 'completo';
  moduleName?: string;
}

export function ProtectedRoute({ 
  children, 
  requirePlan = 'completo',
  moduleName = 'este recurso'
}: ProtectedRouteProps) {
  const { currentPlan, canAccessOperacional } = useCompanyPlan();

  // Se requer plano completo e não tem acesso
  if (requirePlan === 'completo' && !canAccessOperacional) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-200px)] p-8">
        <div className="max-w-md w-full">
          <UpgradePrompt moduleName={moduleName} compact={false} />
        </div>
      </div>
    );
  }

  // Se passou nas verificações, renderiza o conteúdo
  return <>{children}</>;
}